const CURRENT_VERSION = process.env.VUE_APP_VERSION;
const CHECK_INTERVAL_MS = 300000;

export function startVersionCheck() {
    if (!CURRENT_VERSION) {
        return;
    }

    setInterval(checkVersion, CHECK_INTERVAL_MS);
}

function checkVersion() {
    fetch(`${process.env.BASE_URL}index.html?_=${Date.now()}`, { cache: 'no-store' })
        .then(response => response.text())
        .then(html => {
            const match = html.match(/<meta name="app-version" content="([^"]*)">/);
            const deployedVersion = match && match[1];

            if (deployedVersion && deployedVersion !== CURRENT_VERSION) {
                window.location.reload();
            }
        })
        .catch(() => {
            // network hiccup or offline: just retry on the next interval
        });
}
